import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { default_locale, locales } from '../context/locales'

function getPrefersReducedMotion(): boolean {
  const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)')
  return mediaQueryList.matches
}

interface UseGameStateResult {
  gameView: boolean
  setGameView: (gameView: boolean) => void
  animationDisabled: boolean
  setAnimationDisabled: (animationDisabled: boolean) => void
  locale: string
  changeLanguage: (newLang: string) => void
}

export const useGameState = (): UseGameStateResult => {
  const { t, i18n } = useTranslation()
  const locale = locales.map((locale) => locale.key).includes(i18n.language)
    ? i18n.language
    : default_locale
  const [gameView, setGameView] = useState(false)
  const [animationDisabled, setAnimationDisabled] = useState(
    getPrefersReducedMotion(),
  )

  const changeLanguage = (newLang: string) => {
    i18n.changeLanguage(newLang)
    document.documentElement.lang = t('content.languageCode')
    setGameView(false)
  }

  return {
    gameView,
    setGameView,
    animationDisabled,
    setAnimationDisabled,
    locale,
    changeLanguage,
  }
}
